<div class="header for-search" id="main-content-id" [ngClass]="{ dashboard: isDashboard() }">
  <div class="header-wrapper">
    <a
      class="logo-place"
      [routerLink]="!isOnlySearchPage() ? getLogoUrl() : null"
      [queryParams]="!isOnlySearchPage() ? getLogoQueryParams() : null">
      <img
        [src]="isMobileView() ? branding.logoMobileAsset : branding.logoAsset"
        [alt]="branding.title"
        class="logo-img" />
    </a>
    <div class="menu-group">
      <app-search-box
        class="s-box"
        [ngClass]="{ mb: isMobileView() }"
        [label]="'city_name'"
        [viewType]="'mobile'"
        [isMobile]="isMobileView()"
        [showBack]="true"></app-search-box>
    </div>
    @if (isMobileView()) {
    <button class="arrow-btn" aria-label="Menu" (click)="openMobileMainMenu('')">
      <img src="assets/images/hamburger.svg" alt="" />
    </button>
    } @if (!isMobileView()) {
    <div class="side-menus" [ngClass]="{ 'only-search': checkIsOnlySearchPage() }">
      <button class="arrow-btn" aria-label="Menu" (click)="openMobileMainMenu('')">
        <img src="assets/images/hamburger.svg" alt="" />
      </button>
    </div>
    }
  </div>
</div>
